module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/255.fb3da629.png";